<form [formGroup]="form()" [class]="formClassName">
  <select
    [formControlName]="controlName()"
    [class]="selectClassName()"
    [class.placeholder]="!form().value[controlName()]"
  >
    @if (placeholder()) {
      @if (hasOptions()) {
        <option [ngValue]="null" disabled selected hidden>
          {{ placeholder() }}
        </option>
      } @else {
        <option [ngValue]="null" disabled selected>
          {{ placeholder() }}
        </option>
      }
    }

    @for (option of options(); track option.value) {
      <option [ngValue]="option.value">
        {{ option.label }}
      </option>
    }
  </select>
</form>
